import { render, staticRenderFns } from "./partner_avatar.vue?vue&type=template&id=86af0798&scoped=true"
import script from "./partner_avatar.vue?vue&type=script&lang=js"
export * from "./partner_avatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86af0798",
  null
  
)

export default component.exports